import {node_observable_component} from 'common/util/ComponentDecorator';

@node_observable_component
export default class RowValue {
	static classname = 'row-value';

	constructor($value) {
		this.$value = $value;
		this.bindEventListeners();
	}

	bindEventListeners = () => {
		this.$value.on('set_value:parent', (e, args) => {
			this.setValue(args.val);
		});
		this.$value.on('set_label', (e, args) => {
			this.setLabel(args.val);
		});
	};

	setValue = (value) => {
		this.$value.find('.row-value__value-text').html(value);
	};

	setLabel = (label) => {
		this.$value.find('.row-value__label-text').html(label);
	};
};
